var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import cn from 'classnames';
import Typography from '../../internal/Typography';
import withStyles from '../../core/withStyles';
import styles from './Text.styles';
export const Text = (_a, ref) => {
    var { editable, value, maxWidth, autoFocus, error, onChange = () => { }, onBlur, onFocus, children, classes } = _a, props = __rest(_a, ["editable", "value", "maxWidth", "autoFocus", "error", "onChange", "onBlur", "onFocus", "children", "classes"]);
    if (editable) {
        return (_jsx(Typography, Object.assign({}, props, { children: _jsx("input", { ref: ref, type: "text", className: cn(classes.input, error && classes.error), value: value, autoFocus: autoFocus, onChange: (e) => onChange(e.target.value), onBlur: onBlur, onFocus: onFocus, style: { maxWidth } }) })));
    }
    return _jsx(Typography, Object.assign({}, props, { children: children || value }));
};
// @ts-ignore
export default withStyles(styles)(React.forwardRef(Text));
//# sourceMappingURL=Text.js.map